// @flow

import _ from 'lodash';
import React, { type Node } from 'react';

import { FormLabel, SearchableSelectField } from '@zapier/common-components';

import MenuItemComponent from './MenuItemComponent';
import SelectionComponent from './SelectionComponent';

import type { SelectItemType } from '@zapier/common-components';

type Props = {
  autoFocus?: boolean,
  inputId?: string,
  items: Array<SelectItemType>,
  selectedItem: ?SelectItemType,
  label: Node | Array<Node>,
  labelId: string,
  onChange: (item: SelectItemType) => void,
  placeholder?: string,
  search: (
    query?: string,
    services: Array<SelectItemType>
  ) => Array<SelectItemType>,
};

const getKeyForItem = (item: SelectItemType) =>
  item && item.key ? item.key : '';
const getLabelForItem = (item: SelectItemType) =>
  item && item.name ? item.name : '';

/**
 * Renders app picker using zapier-ui SearchableSelectField.
 * SearchableSelectField does most of the work; this component
 * provides custom rendering components for the menu items and
 * the selected item.
 */
const ServiceDropdown = ({
  autoFocus,
  inputId,
  items,
  selectedItem,
  label,
  labelId,
  onChange,
  placeholder = `Search & Select \u2026`,
  search,
}: Props) => {
  // Services.search needs to be called with the original unaltered
  // services, otherwise the ordering gets messed up if you pass enhanced
  // services. But we need to pass enhanced services to the ServiceItem
  // component, so that it can disable services, display premium / beta banner, etc.
  const filterItems = query => search(query, items).slice(0, 25);

  return (
    <div>
      <FormLabel id={labelId}>{label}</FormLabel>
      <SearchableSelectField
        autoComplete="off"
        autoFocus={autoFocus}
        filterItems={filterItems}
        getKeyForItem={getKeyForItem}
        getLabelForItem={getLabelForItem}
        initialSelectedItem={selectedItem}
        inputId={inputId}
        isLoading={_.isEmpty(items)}
        items={items}
        labelId={labelId}
        menuAriaLabel="List of apps"
        MenuItemComponent={MenuItemComponent}
        onChange={onChange}
        placeholder={placeholder}
        SelectionComponent={SelectionComponent}
        shouldSelectOnBlur={false}
      />
    </div>
  );
};

export default ServiceDropdown;
